/* global $ */
/* eslint no-use-before-define: 0 */
/* eslint no-unused-vars: 0  */

// Dropdown Menu - Toggle
// Provides keyboard accessibility behavior for navigation with
// dropdowns, ideally without conflict in cases where both keyboard
// and pointer navigation are used

const $allDropdownParents = $.$body.find(
	'.has-aria-dropdowns li.menu-item-has-children'
);
const $allTriggers = $.$body.find('.dropdown-trigger');
const currentTabTarget = null;
let justOpened = false;

function removeDropdownFocus(event) {
	const { target, relatedTarget, type } = event; // relatedTarget is the old target
	console.log('submenu blur', { target, relatedTarget, type });
	if (relatedTarget) {
		const $oldTargetParent = $(relatedTarget).closest(
			'li.menu-item-has-children'
		);
		const $newTargetParent = $(target).closest('li.menu-item-has-children');
		// console.log({
		//   is: $oldTargetParent.is($newTargetParent),
		//   old: $oldTargetParent.get(0),
		//   newTar: $newTargetParent.get(0),
		// });
		if (!$oldTargetParent.is($newTargetParent)) {
			$oldTargetParent.children('a').removeAttr('tabindex');
			$allDropdownParents.addClass('js-dropdown-closed');
			disableDropDowns();
		}
	}
}

function openDropDown() {
	document.addEventListener('focusin', removeDropdownFocus);
}

function disableDropDowns(wasClick = false) {
	console.log('closing all', $allDropdownParents.length);
	$allDropdownParents.each((i, el) => {
		const $el = $(el);
		const $trigger = $el.find('.dropdown-trigger');
		$el.addClass('js-dropdown-closed')
			.removeClass('js-dropdown-open')
			.attr('aria-expanded', 'false')
			.children('.sub-menu')
			.attr('aria-hidden', 'true');
		$trigger.removeAttr('tabindex').attr('aria-expanded', 'false');
		if (wasClick) {
			$trigger.blur();
		}
	});
	document.removeEventListener('focusin', removeDropdownFocus);
}

window.disableDropDowns = disableDropDowns;

$.$body
	// removes old dropdowns on anything else later tabbed to
	// only if it wasn't a sub-item on the open dropdown
	// .on('focusin', (event) => {
	//   const { target, relatedTarget, type } = event; // relatedTarget is the old target
	//   console.log('submenu blur', { target, relatedTarget, type });
	//   if (relatedTarget) {
	//     const $oldTargetParent = $(relatedTarget).closest(
	//       'li.menu-item-has-children',
	//     );
	//     const $newTargetParent = $(target).closest('li.menu-item-has-children');
	//     // console.log({
	//     //   is: $oldTargetParent.is($newTargetParent),
	//     //   old: $oldTargetParent.get(0),
	//     //   newTar: $newTargetParent.get(0),
	//     // });
	//     if (!$oldTargetParent.is($newTargetParent)) {
	//       $oldTargetParent.children('a').removeAttr('tabindex');
	//       $allDropdownParents.addClass('js-dropdown-closed');
	//       disableDropDowns();
	//     }
	//   }
	// })
	// makes sure that dropdown pointer events on nav item parents close
	// previous dropdowns, even if they were opened by keyboard
	.on('mouseenter', '.has-dropdowns li.menu-item-has-children', (event) => {
		const { target, currentTarget } = event;
		console.log('mouseenter', currentTarget, event);
		$allDropdownParents.addClass('js-dropdown-closed');
		const $menuItem = $(currentTarget);
		$allTriggers.blur();
		$menuItem
			.attr('aria-expanded', 'true')
			.removeClass('js-dropdown-closed')
			.addClass('js-dropdown-open')
			.children('.sub-menu')
			.attr('aria-hidden', 'false');
		$menuItem.find('.dropdown-trigger').attr('aria-expanded', 'false');
		openDropDown();
		justOpened = true;
		setTimeout(() => {
			justOpened = false;
		}, 4);
	})
	// reverses the above
	.on('mouseleave', '.has-dropdowns li.menu-item-has-children', (event) => {
		console.log('mouseleave');
		const { target, currentTarget } = event;
		$allDropdownParents.addClass('js-dropdown-closed');
		$allTriggers.blur();
		const $menuItem = $(currentTarget);
		$menuItem
			.attr('aria-expanded', 'false')
			.removeClass('js-dropdown-open')
			.children('.sub-menu')
			.attr('aria-hidden', 'true');
		$menuItem.find('.dropdown-trigger').attr('aria-expanded', 'false');
		disableDropDowns();
	})
	// distinguishes a true focus event from just a hover event on DD-triggers
	.on('focus', '.dropdown-trigger', (event) => {
		const { target } = event;
		console.log('focus', event, target);
		$(target)
			.closest('li.menu-item-has-children')
			.addClass('js-dropdown-trigger-focus');
	})
	// reverses the above
	.on('blur', '.dropdown-trigger', (event) => {
		const { target, relatedTarget } = event;
		console.log('blur', { event, target, relatedTarget });
		$(target)
			.closest('li.menu-item-has-children')
			.removeClass('js-dropdown-trigger-focus');
	})
	// handles the keypress on any elements that can trigger dropdowns
	.on('keydown click', '.dropdown-trigger', (event) => {
		const { keyCode, currentTarget, type } = event;
		const $trigger = $(currentTarget);
		const $parent = $trigger.closest('li.menu-item-has-children');
		const $submenu = $parent.children('.sub-menu');
		console.log({ open: $parent.hasClass('js-dropdown-open') }, event);
		const isUpArrowActive =
			keyCode === 38 && $parent.hasClass('js-dropdown-open');
		// console.log('keydown on trigger', { keyCode, isUpArrowActive });

		if (
			keyCode === 32 ||
			keyCode === 40 ||
			isUpArrowActive ||
			(type === 'click' && !justOpened)
		) {
			event.preventDefault();
			event.stopImmediatePropagation();

			$parent.toggleClass('js-dropdown-open');

			if ($parent.hasClass('js-dropdown-open')) {
				console.log('opening', type, currentTarget);
				$parent
					.removeClass('js-dropdown-closed')
					.attr('aria-expanded', 'true');
				$trigger.attr('aria-expanded', 'true');
				$submenu.attr('aria-hidden', 'false');
				$parent.children('a').attr('tabindex', '-1');
				openDropDown();
			} else {
				console.log('closing', type, currentTarget);
				// $parent
				//   .addClass('js-dropdown-closed')
				//   .attr('aria-expanded', 'false')
				//   .find('.dropdown-trigger');
				// $trigger.attr('aria-expanded', 'false');
				// $submenu.attr('aria-hidden', 'true');
				// $parent.children('a').removeAttr('tabindex');
				disableDropDowns(true);
			}
		}
	});
